import styled from 'styled-components';
import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';

import { colors } from '@playbookux/playbook-web-core';

const { ERROR_RED } = colors;

const Label = styled.p`
  font-size: ${(props) => (props.fontSize ? props.fontSize : '18px')};
  font-weight: ${(props) => (props.weight === '500' ? props.weight : '400')};
  margin-bottom: 5px;
  color: ${(props) => {
  if (props.error) return ERROR_RED;
  if (props.color) return props.color;
  return '#000';
}}
`;

const CustomDropdown = styled(Dropdown)`
`;

const CustomDropdownMenu = styled(DropdownMenu)`
`;

const CustomDropdownItem = styled(DropdownItem)`
`;

export {
  Label,
  CustomDropdown,
  CustomDropdownMenu,
  CustomDropdownItem,
};
